import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function TrialBanner({ trial }) {
  const [now, setNow] = useState(Date.now);
  const expiresAt = new Date(trial?.expiresAt).getTime();

  useEffect(() => {
    if (!trial?.isActive || !Number.isFinite(expiresAt)) return;
    setNow(Date.now());
    if (expiresAt <= Date.now()) return;
    const interval = setInterval(() => {
      const current = Date.now();
      setNow(current);
      if (current >= expiresAt) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [trial?.isActive, expiresAt]);

  if (!trial?.isActive || !Number.isFinite(expiresAt)) return null;
  const remaining = Math.max(0, Math.ceil((expiresAt - now) / 1000));
  const days = Math.floor(remaining / 86400);
  const hours = Math.floor((remaining % 86400) / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = value => String(value).padStart(2, '0');
  const end = new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(trial.expiresAt));
  return <aside className="bg-morado text-white px-4 py-3">
    <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-between gap-3 text-sm">
      <p>{remaining > 0 ? <><strong>Tu prueba de 5 días está activa.</strong> Termina el {end}, en tu hora local.</> : <strong>Tu prueba de 5 días ha terminado.</strong>}</p>
      <div className="flex items-center gap-3">
        <a href="https://tienda.numerologia-cotidiana.com/productos/numerathum-oraculo-365-agenda-numerologica-2026-digital-pdf" aria-label="Ver Oráculo 365 en la tienda" className="shrink-0 rounded-lg transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#d4af37]">
          <p className="text-xs text-white/80">Tiempo restante</p>
          <p role="timer" aria-label="Tiempo restante de tu prueba" aria-live="off" className="font-mono font-semibold tabular-nums text-[#d4af37] whitespace-nowrap">
            {days}d {pad(hours)}h {pad(minutes)}m {pad(seconds)}s
          </p>
        </a>
        <Link to="/trial/status" className="rounded-lg bg-[#d4af37] text-morado hover:bg-[#d4af37]/90 transition-colors px-3 py-2 font-semibold text-center">Ver mi beneficio del 20%</Link>
      </div>
    </div>
  </aside>;
}
